import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { CancelModelSetupPayload } from './interfaces/cancel-model-setup-payload.interface';

export const CancelModelSetupMessage: MessageHandler<CancelModelSetupPayload> = {
  send(payload: CancelModelSetupPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.CancelModelSetup, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is CancelModelSetupPayload {
    if (!payload || typeof payload !== 'object') {
      return false;
    }

    const p = payload as Record<string, unknown>;
    return (
      typeof p['projectId'] === 'string' &&
      p['projectId'].length > 0 &&
      typeof p['teamId'] === 'string' &&
      p['teamId'].length > 0
    );
  },
};
